export const saveCartConfirmation = (params,history) => ({
    type: 'SAVE_CART_INFO',
    params,
    history
});
export const getChatInfo = (params) => ({
    type: 'GET_CHAT_INFO',
    params,
})
